import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import Logo from "../../assets/img/BUENA RUTA - ISOTIPO 1.png";

const LogLogoImg = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
const LogLogoXs = (props) => {
  const history = useHistory();
  return <LogLogoImg {...props} onClick={() => history.push("/")} src={Logo} />;
};

export default LogLogoXs;
